<template>

  <div class="flex flex-col overflow-hidden flex-grow gap-2 max-h-screen">

    <TRToolbar class="flex-shrink-0  h-[35px]">
      <TRButton @click="saveArticleNumber(false)" class="p-1" text="Speichern" :icon-position="'left'"
                icon="fa-regular fa-floppy-disk"></TRButton>
      <TRButton @click="saveArticleNumber(true)" class="" text="Speichern im Artikelstamm" :icon-position="'left'"
                icon="fa-solid fa-layer-group"></TRButton>
    </TRToolbar>
    <!-- Main Content -->
    <div class="flex  flex-grow overflow-hidden gap-2 ">


      <TRContainer title="Artikelsuche" class="w-[100px] flex-shrink-0 ">

        <div class="flex flex-col gap-2 ">
          <TRInput v-model="articleNumber" :on-enter="changeArticleNumber" :focus-after-clear="true"
                   class="bg-trader-dark-gray p-1  " type="gray" placeholder="Artikelnummer..."></TRInput>
          <div class="flex flex-col overflow-auto gap-2">
            <template v-if="articleNumbers.length > 0" v-for="artn in articleNumbers">
              <div v-if="artn != null && artn !== 'undefined'"
                   class=" min-h-[25px]  p-1 px-2 cursor-pointer hover:bg-trader-blue"
                   :class="artn === articleNumber ? 'bg-trader-blue' : 'bg-trader-light-gray'"
                   @click="loadArticleNumber(artn)">
                {{ artn }}
              </div>
            </template>
          </div>
        </div>
      </TRContainer>


      <TRContainer title="Artikelinformationen" class="flex-grow" :scrollable="true">

        <spinner v-if="loading"></spinner>

        <div v-if="!loading && !exists" class="flex gap-2 font-bold items-center">
          <span class="text-trader-red"> Dieser Artikel existiert noch nicht!</span>

        </div>

        <transition
            enter-active-class="transition-opacity duration-500"
            enter-from-class="opacity-0"
            enter-to-class="opacity-100"
            leave-active-class="transition-opacity duration-500"
            leave-from-class="opacity-100"
            leave-to-class="opacity-0"
        >
          <ProductFormular v-if="!loading && exists" :use-index-d-b="false" :page="page" :form-id="1"
                           :product="product"
                           :show-article-number-input="false" :purchaserId="purchaserId"
                           :key="ready" :form-names="formularNames" :on-change="onProductChanges" :active="true"
                           :on-click-get-image-data="onClickGetImageData" :show-draggable-button="true"
                           :new-image-added="newImageAdded" :showPurchaser="true" :draggable-false="draggableFalse"
                           :on-click-change-draggable="changeDraggable">
          </ProductFormular>
        </transition>
      </TRContainer>


      <TRContainer title="Bildinformationen" class="w-[200px] flex-shrink-0">
        <span>Bildname</span>
        <textarea :readonly="true" class="border-2 border-trader-input p-1 shadow-inner-2 w-full"
                  v-model="pictureInformation.name" rows="2"></textarea>
        <span class="block mt-2">Bildpfad</span>
        <textarea :readonly="true" class="border-2 border-trader-input p-1 shadow-inner-2 w-full"
                  v-model="pictureInformation.previewSmall" rows="3"></textarea>
        <span class="block mt-2">Änderungsdatum</span>
        <textarea :readonly="true" class="border-2 border-trader-input p-1 shadow-inner-2 w-full"
                  v-model="pictureInformation.dateTimeUpdated" rows="1"></textarea>
        <div class="flex flex-col gap-1 pt-2">
          <button class="hover:bg-white border border-trader-light-gray p-1 shadow-inner-2 w-full"
                  @click="openAndHighlightFileInFinder">
            Bild im Finder anzeigen
          </button>
          <button class="hover:bg-white border border-trader-light-gray p-1 shadow-inner-2 w-full"
                  @click="openInPhotoshop">
            Bild in Photoshop öffnen
          </button>
        </div>
      </TRContainer>

    </div>

    <!-- Show in Magazine -->
    <div class=" flex-shrink-0  h-[140px]  overflow-auto">
      <TRTable class="flex-grow" :header="magazineProductHeader" :selected-index="selectedIndex"
               :data-rows="artikelInformation" :singleSelection="true"
               :key="artikelInformation"
               :on-selection-change="magazineSelectionChange">
        <template #cell="{ row, field, selected }">
          <div class="p-1 h-8" v-if="field === 'seTool'">
            <TRButton v-if="row.magazineId" class="hover:bg-trader-blue px-2 h-full min-w-[200px] rounded"
                      icon="fa-solid fa-share"
                      icon-position="left"
                      @click="goToSeTool(row.projektId, row.magazineId, row.pagePosition, row.marketId)">
              Im Werbemittel anzeigen
            </TRButton>
          </div>
          <div v-else class="overflow-hidden whitespace-nowrap text-ellipsis ">
            {{ row[field] }}
          </div>
        </template>
      </TRTable>

    </div>
  </div>

</template>

<script setup lang="ts">
import {onMounted, ref} from 'vue';
import router from "@/router";
import {mutation, query} from "@/graphql";
import Spinner from "@/components/Base/Spinner.vue";
import ProductFormular from "@/components/ProductFormular/ProductFormular.vue";
import SignalBus from "@/application/SignalBus";
import storage from "@/application/storage";
import TRToolbar from "@/components/Base/v2/TRToolbar.vue";
import TRButton from "@/components/Base/v2/TRButton.vue";
import TRContainer from "@/components/Base/v2/TRContainer.vue";
import TRTable from "@/components/Base/TRTable.vue";
import {electron} from "@/electron";
import TRInput from "@/components/Base/v2/TRInput.vue";

const articleNumber = ref();
const articleNumbers = ref([]);
const fields = ref([])
const showEmptyInput = ref(false);
const pictureInformation = ref({});
const pictures = ref([]);
const logos = ref([]);
const selectedPicture = ref();
const idMagazine = ref(0);
const idMarket = ref(0);
const loading = ref(false);
const oldDataPicture = ref([]);
const oldDataLogo = ref([]);
const oldDataFields = ref([]);
const productJoinProductPictureId = ref(0);
const productJoinProductLogoId = ref(0);
const searchArticleIndex = ref(0);
const formularNames = ref([]);
const ready = ref(0);
const purchasers = ref([]);
const purchaserId = ref(116);
const exists = ref(false);
const draggableFalse = ref(false);
const pictureResult = ref([]);
const logoResult = ref([]);
let selectedIndex = ref(0);

const magazineProductHeader = [
  {title: 'Produktname', field: 'produktName'},
  {title: 'Seite', field: 'pagePosition', width: 50},
  {title: 'Werbemittel', field: 'magazineName'},
  {title: 'Markt', field: 'marketName'},
  {title: 'Aktionen', field: 'seTool', width: 200}
];

const magazineSelectionChange = (selectedRows) => {

  if (selectedRows.length > 0) {
    const selectedId = selectedRows[0]?.id || 0;
    selectedIndex.value = artikelInformation.value.findIndex((item) => item.id === selectedId);
    idMagazine.value = artikelInformation.value[selectedIndex.value].magazineId;
    idMarket.value = artikelInformation.value[selectedIndex.value].marketId;
    loadData();
  }
}

let lastProductChanges = {};

const page = ref({
  pagePosition: 0,
  magazineId: 0,
  pageId: 0,
  projectId: 0,
});
const product = ref({
  productId: 0,
  articleNumber: articleNumber.value,
  productTemplateId: 0,
  productTemplateName: '',
  placeholderId: 0,
  productCustomFields: fields.value,
  productPictures: pictures.value,
  productLogos: logos.value,
})

const artikelInformation = ref([]);

async function getFormularNames() {
  const [data, err] = await query.getFormularNames();
  formularNames.value = data;
  if (err) {
    console.error(err);
  }
}

function changeDraggable() {
  draggableFalse.value = !draggableFalse.value;
}

async function newImageAdded(image, type) {
  // getImageByPath
  
  if (type == 'picture') {
    product.value.productPictures.push(image);
    //ready.value = Math.random();
  } else {
    product.value.productLogos.push(image);
    //ready.value = Math.random();
  }
}

function onClickGetImageData(image) {
  pictureInformation.value = image;
}

async function createArtikelNumber() {
  try {

    await mutation.createArtikelNumber(articleNumber.value, purchaserId.value);
    await loadData();
  } catch (e) {
    console.error(e);
  }
}

const openInPhotoshop = () => {
  let picture = pictureInformation.value.originalFilePath;
  electron.openFileInPhotoshop(picture);
};

const openAndHighlightFileInFinder = () => {
  let picture = pictureInformation.value.originalFilePath;
  electron.openFileInFinder(picture);
};

async function loadData() {
  if (!articleNumber.value) {
    return;
  }
  const [data, err] = await query.getArticleInformation(articleNumber.value, idMagazine.value, idMarket.value);
  if (err) {
    console.error(err);
  }
  if (!showEmptyInput.value) {
    fields.value = data?.fields.filter((field: any) => field.fieldValue !== "");
  } else {
    fields.value = data?.fields;
  }
  pictures.value = data?.picture;
  logos.value = data?.logo;

  exists.value = data?.exists;
  if (data?.exists) {
    product.value.productCustomFields = data?.fields;
    product.value.productPictures = data?.picture;
    product.value.productLogos = data?.logo;
    product.value.productId = data?.productId;
    product.value.productTemplateId = data?.templateId;
    page.value.pageId = data?.pageId;
    page.value.magazineId = idMagazine.value;
    purchaserId.value = data?.purchaserId;

    oldDataPicture.value = data?.picture;
    oldDataLogo.value = data?.logo;
    oldDataFields.value = data?.fields;
  }
  //random id
  ready.value = Math.random();
}

async function getPurchasers() {
  const [data, err] = await query.getPurchasers();
  purchasers.value = data;
  if (err) {
    console.error(err);
  }

}

function loadArticleNumber(newArticleNumber) {
  articleNumber.value = newArticleNumber;  // Update the value of the ref
  searchForArticleNumber();
  loadData();
}

async function goToSeTool(projectId, magazineId, pagePosition, marketId) {

  /// query.getAccordionIndex
  const [data, err] = await query.getAccordionIndex(magazineId, pagePosition, marketId, articleNumber.value);
  if (err) {
    console.error(err);
  }
  await router.push('/project/' + projectId + '/' + magazineId + '/' + pagePosition + '/' + marketId + '/' + data);
}

function removePicture() {
  pictures.value.forEach((picture) => {
    if (picture.productJoinProductPictureId === pictureInformation.value.productJoinProductPictureId) {
      picture.delete = true;
    }
  })
  logos.value.forEach((logo) => {
    if (logo.productJoinProductPictureId === pictureInformation.value.productJoinProductPictureId) {
      logo.delete = true;
    }
  })
}


function changeArticleNumber() {
  // trim " " from articleNumber
  articleNumber.value = articleNumber.value.trim();
  if (articleNumber.value === '') {
    return;
  }
  if (!articleNumbers.value.includes(articleNumber.value)) {
    articleNumbers.value.push(articleNumber.value);
  }
  searchForArticleNumber();
  loadData();
}

async function searchForArticleNumber() {

  if (articleNumber.value === '') {
    return;
  }
  let [data, err] = await query.searchWhereArticleNumberIs(articleNumber.value);
  try {
    artikelInformation.value = data;
  } catch (e) {
    console.error(e);
  }
}

function toggleEmptyInput() {
  showEmptyInput.value = !showEmptyInput.value;
  loadData();
}

function toggle(value) {
  if (value === 'Aktiv') {
    pictureInformation.value.isActive = !pictureInformation.value.isActive

  } else {
    pictureInformation.value.isDefault = !pictureInformation.value.isDefault
  }
  pictures.value.forEach((picture) => {
    if (picture.productJoinProductPictureId === pictureInformation.value.productJoinProductPictureId) {
      picture.isActive = pictureInformation.value.isActive;
      picture.isDefault = pictureInformation.value.isDefault;
    } else {
      picture.isDefault = false;
    }
  })
  logos.value.forEach((logo) => {
    if (logo.productJoinProductPictureId === pictureInformation.value.productJoinProductPictureId) {
      logo.isActive = pictureInformation.value.isActive;
      logo.isDefault = pictureInformation.value.isDefault;
    } else {
      logo.isDefault = false;
    }
  })
}

function getImageInformation(value) {
  pictureInformation.value = value;
  if (value.productJoinProductPictureId) {
    productJoinProductPictureId.value = value.productJoinProductPictureId;
  }
  if (value.productJoinProductLogoId) {
    productJoinProductLogoId.value = value.productJoinProductLogoId;
  }
}

function onDragUpdate(event, type) {
  if (type === 'picture') {
    this.pictures.forEach((picture, index) => {
      picture.position = index + 1;
    });
  } else {
    this.logos.forEach((logo, index) => {
      logo.position = index + 1;
    });
  }

}


//vue composition api on created


onMounted(async () => {
  const artNo = router.currentRoute.value.params.articleNumber;

  articleNumber.value = await storage.get("articleNumber");


  const splitArticleNumbers = artNo.split(/[\s,]+/).filter(item => item.trim() !== '' && item.trim() !== null);
  if (splitArticleNumbers.length > 0) {
    articleNumbers.value = splitArticleNumbers;
    articleNumber.value = splitArticleNumbers[0];
  }


  await loadData();
  await getFormularNames();
  await searchForArticleNumber();
  await getPurchasers();

});

function resetChanges() {
  pictures.value = oldDataPicture.value;
  logos.value = oldDataLogo.value;
  fields.value = oldDataFields.value;
}

function onProductChanges(data) {

  
  lastProductChanges = data
}

function resetHighlights() {
}

async function saveArticleNumber(bool) {
  try {
    loading.value = true;

    let pictureChanges = [];
    let logoChanges = [];
    let fieldChanges = [];


    for (const [_, v] of Object.entries(lastProductChanges)) {
      if (v.type === 'field') {


        fieldChanges.push({
          value: v.value,
          field: v.key,
          productCustomFieldId: 0,
          productId: product.value.productId
        })

      }
      if (v.type === 'picture') {
        // Durchlaufe das Array innerhalb von v.value
        v.value.forEach(picture => {
          pictureChanges.push({
            productJoinProductPictureId: picture.productJoinProductPictureId,
            productPictureId: picture.productPictureId,
            teamId: picture.teamId,
            isActive: picture.isActive,
            previewSmall: picture.previewSmall,
            previewMedium: picture.previewMedium,
            previewLarge: picture.previewLarge,
            position: picture.position,
            markedForDeletion: picture.markedForDeletion,
            isDefault: picture.isDefault,
            name: picture.name,
            dateTimeCreated: picture.dateTimeCreated,
            dateTimeUpdated: picture.dateTimeUpdated,
            delete: picture.delete,
            added: picture.add || false,
            originalFilePath: picture.originalFilePath,
            isRemoved: picture.isRemoved || false
          });
        });
      }
      if (v.type === 'logo') {
        v.value.forEach(logo => {
          logoChanges.push({
            productJoinProductLogoId: logo.productJoinProductLogoId,
            productLogoId: logo.productLogoId,
            teamId: logo.teamId,
            isActive: logo.isActive,
            previewSmall: logo.previewSmall,
            previewMedium: logo.previewMedium,
            previewLarge: logo.previewLarge,
            position: logo.position,
            markedForDeletion: logo.markedForDeletion,
            name: logo.name,
            dateTimeCreated: logo.dateTimeCreated,
            dateTimeUpdated: logo.dateTimeUpdated,
            delete: logo.delete,
            added: logo.add || false,
            originalFilePath: logo.originalFilePath,
            isRemoved: logo.isRemoved || false
          });
        });
      }
    }

    const data = {
      saveInBaseArticle: bool,
      purchaserId: purchaserId.value,
      articleNumber: articleNumber.value,
      magazineId: idMagazine.value || 0,
      marketId: idMarket.value || 0,
      fields: fieldChanges || [],
      picture: pictureChanges || [],
      logo: logoChanges || []
    }
    await mutation.saveArticleNumber(data);
    SignalBus.emit('resetHighlights');

  } catch (e) {
    console.error(e);
  } finally {
    await loadData()
    await searchForArticleNumber();
    loading.value = false;

  }
}

function removeDuplicatesByOriginalFilePath(array) {
  const seen = new Set();
  return array.filter(item => {
    if (seen.has(item.originalFilePath)) {
      return false; // Ignoriere das Element, wenn es bereits gesehen wurde
    }
    seen.add(item.originalFilePath);
    return true; // Behalte das Element, wenn es noch nicht gesehen wurde
  });
}

</script>

